var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tag',{attrs:{"type":_vm.colorMap[_vm.code],"size":"small"}},[_vm._v(" "+_vm._s(_vm._f("enumsMap")(_vm.code,_vm.enums))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }